import type { AtlasUploadOptionsValue } from './AtlasUploadOptionsFields';
import type { GlSource } from './utils/parseFundFromFilename';

// 'uploading' = PUT to S3 in flight; 'processing' = uploaded, backend ingest running
// (polled via the carta status endpoint); 'success'/'error' are the terminal outcomes.
export type FileUploadStatus = 'pending' | 'uploading' | 'processing' | 'success' | 'error';

export interface FileUploadEntry {
  file: File;
  source: GlSource | null;
  detectedFundName: string | null;
  detectedDate: string | null;
  parseError: string | null;
  status: FileUploadStatus;
  errorMessage: string | null;
  /** Per-file Atlas-pipeline opts. Co-located with the entry so remove/add
   *  operations on the row naturally drop or initialize the opts in lockstep.
   *  Ignored when route='carta'. Initialized via defaultAtlasUploadOptions(). */
  atlasOpts: AtlasUploadOptionsValue;
}

export type FileUploadAction =
  | { type: 'ADD_FILES'; entries: FileUploadEntry[] }
  | { type: 'REMOVE_FILE'; index: number }
  | { type: 'SET_STATUS'; index: number; status: FileUploadStatus; errorMessage?: string }
  | { type: 'SET_ATLAS_OPTS'; index: number; atlasOpts: AtlasUploadOptionsValue }
  | { type: 'RESET' };

export function fileUploadReducer(state: FileUploadEntry[], action: FileUploadAction): FileUploadEntry[] {
  switch (action.type) {
    case 'ADD_FILES':
      return [...state, ...action.entries];
    case 'REMOVE_FILE':
      return state.filter((_, i) => i !== action.index);
    case 'SET_STATUS':
      return state.map((entry, i) =>
        i === action.index
          ? { ...entry, status: action.status, errorMessage: action.errorMessage ?? entry.errorMessage }
          : entry
      );
    case 'SET_ATLAS_OPTS':
      return state.map((entry, i) =>
        i === action.index ? { ...entry, atlasOpts: action.atlasOpts } : entry
      );
    case 'RESET':
      return [];
    default:
      return state;
  }
}
